export enum Loader {
  yes = 'yes',
  no = 'no',
}
